var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "main-content", staticStyle: { overflow: "auto" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isPreview,
                  expression: "!isPreview"
                }
              ],
              class: _vm.readonly ? "not-click" : "",
              staticStyle: { width: "fit-content" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                _vm._l(_vm.blocks, function(block) {
                  return _c(
                    "div",
                    {
                      key: block.pagePart.pagePartName,
                      staticClass: "section",
                      staticStyle: { width: "336px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: {
                            height: "100%",
                            display: "flex",
                            "flex-direction": "column"
                          },
                          attrs: {
                            disabled: _vm.readonly,
                            "label-width": "140px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c("el-form-item", { attrs: { label: " " } }, [
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Display") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Display")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Required") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Required")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                staticStyle: { width: "80px" },
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.Alias")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.Alias"))
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("Tool.Setting") }
                              },
                              [_vm._v(_vm._s(_vm.$t("Tool.Setting")))]
                            )
                          ]),
                          _vm._l(
                            block.serialNumber === 1
                              ? _vm.firstBlockElements
                              : block.uiCustomElementList,
                            function(element) {
                              return _c(
                                "el-form-item",
                                { key: element.pagePartElement.elementName },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: element.isRequire ? "blue" : "",
                                      attrs: { slot: "label" },
                                      slot: "label"
                                    },
                                    [_vm._v(_vm._s(element.sysLabel))]
                                  ),
                                  _c("el-checkbox", {
                                    staticClass: "element-column-content",
                                    attrs: {
                                      disabled:
                                        !element.pagePartElement
                                          .displayCanCustom ||
                                        (!!element.hqUICustomElement &&
                                          element.hqUICustomElement
                                            .isRequire) ||
                                        _vm.checkHqSetDisable(element)
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onDisplayChange(
                                          block,
                                          element
                                        )
                                      }
                                    },
                                    model: {
                                      value: element.isDisplay,
                                      callback: function($$v) {
                                        _vm.$set(element, "isDisplay", $$v)
                                      },
                                      expression: "element.isDisplay"
                                    }
                                  }),
                                  _c("el-checkbox", {
                                    staticClass: "element-column-content",
                                    attrs: {
                                      disabled:
                                        !element.pagePartElement
                                          .requireCanCustom ||
                                        (!!element.hqUICustomElement &&
                                          element.hqUICustomElement
                                            .isRequire) ||
                                        !element.isDisplay ||
                                        _vm.checkHqSetDisable(element)
                                    },
                                    model: {
                                      value: element.isRequire,
                                      callback: function($$v) {
                                        _vm.$set(element, "isRequire", $$v)
                                      },
                                      expression: "element.isRequire"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "element-column-text",
                                      staticStyle: {
                                        width: "80px",
                                        "pointer-events": "auto"
                                      },
                                      attrs: { title: element.customLabel }
                                    },
                                    [_vm._v(_vm._s(element.customLabel))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "element-column-content" +
                                        (element.pagePartElement
                                          .aliasCanCustom &&
                                        _vm.branchId === 1 &&
                                        element.isDisplay
                                          ? ""
                                          : " el-icon-edit-disabled")
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-edit",
                                        on: {
                                          click: function($event) {
                                            return _vm.onEditElementLabel(
                                              element
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            }
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _vm.isPreview
            ? _c("cargo-ag-grid", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": []
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("element-set-dialog", {
        attrs: {
          visible: _vm.elementSetDialog.visible,
          element: _vm.elementSetDialog.element
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.elementSetDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }